
export class AnalysisWorkflowType {
    public static readonly UNKNOWN = 'Unknown';
    public static readonly AMPLICON = 'Amplicon';
    public static readonly DENOVO_ASSEMBLY = 'DenovoAssembly';
    public static readonly META_GENOMICS = 'Metagenomics';
    public static readonly RESEQUENCING = 'Resequencing';
    public static readonly SMALL_RNA = 'SmallRna';
    public static readonly LIBRARY_QC = 'LibraryQc';
    public static readonly ISAAC = 'iSAAC';
    public static readonly PCR_AMPLICON = 'PCRAmplicon';
    public static readonly GENERATE_FASTQ = 'GenerateFASTQ';
    public static readonly HISEQ_FASTQ = 'HiSeqFastQ';
    public static readonly NO_ANALYSIS = 'NoAnalysis';
    public static readonly ENRICHMENT = 'Enrichment';
    public static readonly TARGETED_RNASEQ = 'TargetedRNASeq';
}

export class AnalysisWorkflowTypeDescription {
    public static readonly UNKNOWN = 'Unknown';
    public static readonly AMPLICON = 'Custom Amplicon';
    public static readonly DENOVO_ASSEMBLY = 'de novo Assembly';
    public static readonly META_GENOMICS = 'Metagenomics';
    public static readonly RESEQUENCING = 'Resequencing';
    public static readonly SMALL_RNA = 'Small RNA';
    public static readonly LIBRARY_QC = 'Library QC';
    public static readonly ISAAC = 'iSAAC';
    public static readonly PCR_AMPLICON = 'PCR Amplicon';
    public static readonly GENERATE_FASTQ = 'Generate FASTQ';
    public static readonly HISEQ_FASTQ = 'HiSeqFastQ';
    public static readonly NO_ANALYSIS = 'No Analysis';
    public static readonly ENRICHMENT = 'Enrichment';
    public static readonly TARGETED_RNASEQ = 'Targeted RNA Seq';
}

// Currently we support all workflow types, including NoAnalysis workflow which was previously disallowed (BASE-83873)
export const REQUEUE_NOT_SUPPORTED_WORKFLOWS = [];
